import { Box, Button, Container, Typography } from '@mui/material';
import { Link as RouterLink } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { EmojiSadOutlined as EmojiSadIcon } from '../icons/emoji-sad-outlined';

export const NotFound = () => {
  const { t } = useTranslation(['common']);

  return (
    <Box sx={{ backgroundColor: 'background.default' }}>
      <Container
        maxWidth="md"
        sx={{
          px: 5,
          py: 14,
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <EmojiSadIcon sx={{ color: 'text.secondary' }} />
        <Typography align="center" color="textPrimary" sx={{ my: 2 }} variant="h3">
          {t('common:notFound.title')}
        </Typography>
        <Typography align="center" color="textSecondary" variant="body2">
          {t('common:notFound.description')}
        </Typography>
        <Button color="primary" component={RouterLink} sx={{ mt: 2 }} to="/" variant="text">
          {t('common:notFound.takeMeHome')}
        </Button>
      </Container>
    </Box>
  );
};
